import {
  ItemOffer,
  ItemOfferRequest,
  OfferRequest,
} from '@dgx-pr-spa/shared/util';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from '@core/services/core.service';
import { FeatureFlagService } from '@shared/services/feature-flag.service';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

// import { mockItemOfferData } from '@dgx-pr-spa/shared/util';
// import { mockOffersBespoke } from '@dgx-pr-spa/shared/util';
// import { mockOffers, mockOffersCompare } from '@dgx-pr-spa/shared/util';
// import { delay } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class OfferBackendService {
  itemOffer: ItemOffer;

  constructor(
    public http: HttpClient,
    private router: Router,
    public coreService: CoreService,
    private featureFlagService: FeatureFlagService
  ) {}

  httpState$ = this.coreService.httpState$;

  fetchOffers(url: string, payload: OfferRequest) {
    return this.http
      .get(
        `${this.featureFlagService.loadedConfig.new_API}/api/v1/offers/${payload.offer_reference}`
      )
      .pipe(
        catchError((error: Response) => {
          this.handleStatus(error, 'fetch offers');
          return throwError(error);
        })
      );
  }

  postOffer(url: string, data: ItemOfferRequest): Observable<ItemOffer> {
    return this.http
      .post(
        `${this.featureFlagService.loadedConfig.new_API}/api/v1/item-offer`,
        data
      )
      .pipe(
        tap((val: ItemOffer) => {
          this.itemOffer = val;
        })
      );
  }

  handleStatus(error: Response, caller: string) {
    const msg = `${error.status} ${error.statusText} ${caller}`;
    this.router.navigate(['/error'], {
      queryParams: { msg },
      replaceUrl: true,
    });
  }
}
